"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const NonMusicalToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { title: 'Non-Musical Work', info: 'When a registered work is categorized as a non-musical work, the registration is marked as non-musical in The MLC database. Non-musical works should not be registered with The MLC. Royalties are not allocated or paid to identified non-musical works.', place: 'top' }));
exports.default = NonMusicalToolTip;
